<template>
  <el-popover ref="popover" placement="bottom-start" trigger="focus" :visible-arrow="false" width="240" @show="focus" @hide="blur" popper-class="myPopover">
    <div class="menu">
      <el-scrollbar ref='scrollbar' wrapStyle='max-height:350px;'>
        <template v-if="isSearch">
          <ul class="menus">
            <li class="options" :class="{'selected': item.checked}" v-for="(item,index) in searchArr" :key="index" @click="handleSelect(item)">
              <div>
                <span>{{item.label}}</span>
                <i class="el-icon-check" v-if="item.checked"></i>
              </div>
            </li>
          </ul>
          <div v-if="!searchArr.length" class="nodata">无匹配数据</div>
        </template>

        <transition name="el-fade-in-linear" mode="in-out">
          <template v-if="!isSearch">
            <ul class="menus">
              <li class="options" :class="{'selected': item.checked}" v-for="(item,index) in copyOptions" :key="index" @click="handleSelect(item)">
                <div>
                  <span>{{item.label}}</span>
                  <i class="el-icon-check" v-if="item.checked"></i>
                </div>
              </li>
            </ul>
          </template>
        </transition>
      </el-scrollbar>
    </div>
    <div class="condition-name" slot="reference">
      <tag-input v-model="value" ref="tagInput" class="tagInput" :class="{'error-border':error}" :placeholder="placeholder" :allowEnter="false" @afterAdd='afterAdd' @getFocus="getFocus"
        @change="inputSearch" @deleteTag="deleteTag" />
    </div>
  </el-popover>
</template>

<script>
import tagInput from './tagInput.vue'

import mixin from '../stopon.js'

export default {
  mixins: [mixin],
  props: ['value', 'options', 'error', 'glId'],
  components: { tagInput },
  data() {
    return {
      placeholder: '请选择',
      copyOptions: [],
      isSearch: false,
      searchArr: []
    }
  },
  computed: {

  },
  mounted() {
    this.copyOptions = JSON.parse(JSON.stringify(this.options))
    this.echo()

    if (this.glId == 33) {
      this.placeholder = '请选择年报年份'
    }
  },
  methods: {
    getFocus() {
      if (!this.$refs.tagInput.word) {
        this.afterAdd()
      }
    },
    afterAdd() {
      this.isSearch = false
      this.echo()
      this.searchArr = []
    },
    inputSearch(val) {
      if (val) {
        this.isSearch = true
        this.searchArr = this.copyOptions.filter(e => {
          if (e.label.includes(val)) {
            return true
          }
        })
      } else {
        this.isSearch = false
      }
    },
    deleteTag() {
      this.echo()
    },
    echo() {
      this.copyOptions.forEach(e => {
        this.$set(e, 'checked', false)
        if (this.value.findIndex(ee => ee.value === e.value) !== -1) {
          this.$set(e, 'checked', true)
        }
      })
    },
    handleSelect(val) {
      if (val.checked) {
        val.checked = false
        this.$refs.tagInput.removeItem(val.value)
      } else {
        // 判断上限
        if (this.$refs.tagInput.isMax()) return
        this.$set(val, 'checked', true)
        this.$refs.tagInput.addItem(val)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.nodata {
  text-align: center;
  font-size: 12px;
  color: #999;
}
.error-border {
  border-color: #f04134 !important;
  box-shadow: 0px 0px 4px 0px rgba(240, 65, 52, 0.4);
}
.el-icon-error {
  right: 8px;
  position: absolute;
  font-size: 14px;
  top: 50%;
  color: #d9d9d9;
  transform: translateY(-50%);
}
.multi-option {
  margin-top: 4px !important;
}
.tagInput {
  width: 300px;
}
.options {
  cursor: pointer;
  height: 34px;
  line-height: 34px;
  padding: 0 16px;
  box-sizing: border-box;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &:hover {
    background-color: #ebf0fe;
  }
  &.selected {
    color: #4f7afd;
  }
}
</style>
<style lang='scss'>
.myPopover {
  padding: 8px 0;
  .options {
    padding: 0 16px 0 20px;
    box-sizing: border-box;
    height: 36px;
    line-height: 36px;
    color: #262626;
    font-size: 14px;
    &:hover {
      background-color: #f1f2f4;
    }
    &.selected {
      color: #5088ff;
    }
    .el-icon-check {
      background: url("~@/assets/gbIcon/checked.svg") center;
      width: 20px;
      height: 20px;
      &::before {
        content: "";
      }
    }
  }
}
</style>
